import { useState } from "react";
import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Loader2, ScanLine } from "lucide-react";
import BarcodeScanner from "./BarcodeScanner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "./ui/dialog";

const FIELDS = {
  customer: [
    ["name", "Customer name", true],
    ["contact_person", "Contact person"],
    ["email", "Email"],
    ["phone", "Phone"],
    ["billing_address", "Billing address"],
  ],
  site: [
    ["name", "Site name", true],
    ["address", "Address"],
  ],
  pump: [
    ["manufacturer", "Manufacturer"],
    ["model", "Model"],
    ["indoor_unit", "Indoor unit model"],
    ["indoor_serial_number", "Indoor unit serial number"],
    ["outdoor_unit", "Outdoor unit model"],
    ["serial_number", "Serial number"],
    ["refrigerant_type", "Refrigerant type"],
  ],
};
const TITLES = { customer: "New customer", site: "New site", pump: "New heat pump" };

export function QuickAddDialog({ type, form, setForm, onSave, saving, onClose, title }) {
  const [scanKey, setScanKey] = useState(null);
  return (
    <Dialog open={!!type} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-h-[90vh] overflow-auto">
        <DialogHeader>
          <DialogTitle>{title || TITLES[type] || ""}</DialogTitle>
          <DialogDescription>
            Add the details now — you can fill in the rest later on site.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {(type ? FIELDS[type] : []).map(([k, label, required]) => {
            const scannable = k.includes("serial");
            return (
              <div key={k} className="space-y-1.5">
                <Label>
                  {label}
                  {required ? " *" : ""}
                </Label>
                <div className="flex gap-2">
                  <Input
                    value={form[k] || ""}
                    onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                    className="h-11"
                    data-testid={`quickadd-${k}`}
                  />
                  {scannable && (
                    <Button
                      type="button"
                      variant="outline"
                      className="h-11 shrink-0 px-3"
                      onClick={() => setScanKey(k)}
                      data-testid={`scan-${k}`}
                      title="Scan barcode"
                    >
                      <ScanLine className="h-4 w-4" />
                    </Button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <DialogFooter>
          <Button className="h-11 w-full" onClick={onSave} disabled={saving} data-testid="quickadd-save">
            {saving && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />}
            Save
          </Button>
        </DialogFooter>

        <BarcodeScanner
          open={!!scanKey}
          label={scanKey ? scanKey.replace(/_/g, " ") : "serial number"}
          onDetected={(text) => {
            setForm({ ...form, [scanKey]: text });
            setScanKey(null);
          }}
          onClose={() => setScanKey(null)}
        />
      </DialogContent>
    </Dialog>
  );
}
